<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>客服信息</span>
      <el-button v-if="$hasPermission('mall:customer-service:save')" type="primary" size="mini" @click="openCreate">新增客服信息</el-button>
    </div>

    <div class="search-bar search-wrap">
      <el-input
        v-model.trim="query.phone"
        placeholder="请输入客服电话"
        clearable
        style="width: 220px"
        @keyup.enter.native="handleSearch"
      />
      <el-select v-model="query.status" clearable placeholder="状态" style="width: 140px">
        <el-option :value="1" label="启用" />
        <el-option :value="0" label="停用" />
      </el-select>
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="id" label="编号" width="90" align="center" />
      <el-table-column prop="phone" label="客服电话" min-width="150" align="center" />
      <el-table-column prop="contactTime" label="联系时间" min-width="180" align="center" />
      <el-table-column label="客服二维码" width="120" align="center">
        <template slot-scope="{ row }">
          <el-image
            v-if="row.qrCodeUrl"
            class="qr-preview"
            :src="row.qrCodeUrl"
            :preview-src-list="[row.qrCodeUrl]"
            fit="cover"
          />
          <span v-else class="empty-text">未上传</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="180" align="center" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">
            {{ row.status === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" align="center" />
      <el-table-column prop="updateTime" label="更新时间" width="180" align="center" />
      <el-table-column label="操作" width="260" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button v-if="$hasPermission('mall:customer-service:update')" size="mini" @click="openEdit(row)">编辑</el-button>
          <el-button
            v-if="$hasPermission('mall:customer-service:update')"
            :type="row.status === 1 ? 'warning' : 'success'"
            size="mini"
            @click="toggleStatus(row)"
          >
            {{ row.status === 1 ? '停用' : '启用' }}
          </el-button>
          <el-button v-if="$hasPermission('mall:customer-service:delete')" size="mini" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog :title="form.id ? '编辑客服信息' : '新增客服信息'" :visible.sync="dialogVisible" width="620px" :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="客服电话" prop="phone">
          <el-input v-model.trim="form.phone" placeholder="请输入客服电话或手机号码" />
        </el-form-item>
        <el-form-item label="联系时间" prop="contactTime">
          <el-input v-model.trim="form.contactTime" placeholder="例如：工作日 09:00-18:00" />
        </el-form-item>
        <el-form-item label="客服二维码">
          <div class="upload-row">
            <el-upload
              v-if="$hasPermission('mall:customer-service:upload')"
              class="qr-uploader"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              accept="image/*"
            >
              <el-button size="small" type="primary">上传二维码</el-button>
            </el-upload>
            <el-button v-if="form.qrCodeUrl" size="small" @click="form.qrCodeUrl = ''">清除二维码</el-button>
          </div>
          <el-image
            v-if="form.qrCodeUrl"
            class="form-qr-preview"
            :src="form.qrCodeUrl"
            :preview-src-list="[form.qrCodeUrl]"
            fit="cover"
          />
          <div class="form-tip">二维码上传使用客服信息独立接口，不会写入图片信息库。</div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model.trim="form.remark" type="textarea" :rows="3" placeholder="可填写客服说明" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          v-if="$hasPermission(form.id ? 'mall:customer-service:update' : 'mall:customer-service:save')"
          type="primary"
          @click="save"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'

const baseURL = process.env.NODE_ENV === 'development' ? '/ssy-mall-server' : ''

function defaultQuery () {
  return {
    page: 1,
    limit: 10,
    phone: '',
    status: null
  }
}

function defaultForm () {
  return {
    id: null,
    phone: '',
    contactTime: '',
    qrCodeUrl: '',
    remark: '',
    status: 1
  }
}

export default {
  data () {
    return {
      query: defaultQuery(),
      total: 0,
      list: [],
      dialogVisible: false,
      form: defaultForm(),
      rules: {
        phone: [{ required: true, message: '请输入客服电话', trigger: 'blur' }],
        contactTime: [{ required: true, message: '请输入联系时间', trigger: 'blur' }]
      }
    }
  },
  computed: {
    uploadUrl () {
      return `${baseURL}/mall/customer-service/upload-qr-code`
    },
    uploadHeaders () {
      const token = localStorage.getItem('token')
      return token ? { token } : {}
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      const { data } = await http.get('/mall/customer-service/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    openCreate () {
      this.form = defaultForm()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    async openEdit (row) {
      const { data } = await http.get(`/mall/customer-service/info/${row.id}`)
      const info = data.data || {}
      this.form = {
        id: info.id,
        phone: info.phone || '',
        contactTime: info.contactTime || '',
        qrCodeUrl: info.qrCodeUrl || '',
        remark: info.remark || '',
        status: Number(info.status == null ? 1 : info.status)
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    toggleStatus (row) {
      const nextStatus = row.status === 1 ? 0 : 1
      const actionText = nextStatus === 1 ? '启用' : '停用'
      this.$confirm(`确定${actionText}客服电话“${row.phone}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/customer-service/status', {
          id: row.id,
          status: nextStatus
        })
        if (data.code === 0) {
          this.$message.success(`客服信息已${actionText}`)
          this.load()
        }
      })
    },
    beforeUpload (file) {
      if (!file.type || !file.type.startsWith('image/')) {
        this.$message.error('只能上传图片文件')
        return false
      }
      return true
    },
    handleUploadSuccess (response) {
      if (response && response.code === 0) {
        const payload = response.data || {}
        this.form.qrCodeUrl = payload.url || payload.accessUrl || ''
        this.$message.success('客服二维码上传成功')
        return
      }
      this.$message.error((response && (response.msg || response.message)) || '客服二维码上传失败')
    },
    handleUploadError () {
      this.$message.error('客服二维码上传失败')
    },
    save () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        const payload = {
          id: this.form.id,
          phone: this.form.phone,
          contactTime: this.form.contactTime,
          qrCodeUrl: this.form.qrCodeUrl,
          remark: this.form.remark,
          status: this.form.status
        }
        const url = this.form.id ? '/mall/customer-service/update' : '/mall/customer-service/save'
        const { data } = await http.post(url, payload)
        if (data.code === 0) {
          this.$message.success(this.form.id ? '客服信息修改成功' : '客服信息新增成功')
          this.dialogVisible = false
          this.load()
        }
      })
    },
    remove (row) {
      this.$confirm(`确定删除客服电话“${row.phone}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/customer-service/delete', [row.id])
        if (data.code === 0) {
          this.$message.success('客服信息删除成功')
          this.load()
        }
      })
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.pagination-bar {
  margin-top: 12px;
  text-align: right;
}

.qr-preview {
  width: 48px;
  height: 48px;
  border-radius: 6px;
}

.empty-text,
.form-tip {
  color: #909399;
  font-size: 12px;
}

.upload-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.form-qr-preview {
  width: 120px;
  height: 120px;
  margin-top: 10px;
  border-radius: 8px;
}
</style>
